import(/* webpackMode: "eager" */ "/vercel/path0/src/app/kartela/page.tsx");
